import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Router, Switch } from 'react-router-dom';

import '@babel/polyfill';
import 'fontsource-roboto';
import moment from 'moment';
import 'moment/locale/fr';

import { CssBaseline, Grid } from '@mui/material';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

import DeliverySelfSingOutContainer from './components/Delivery/DeliverySelfSingOutContainer';
import MainContainer from './components/Main/MainContainer';

import LayoutComponent from './components/Main/LayoutComponent';
import MainCallCenterComponent from './components/Main/MainCallCenterComponent';

import { hideSplashScreen } from './components/Main/utils';

import ErrorBoundary from './components/Main/ErrorBoundary';
import PopupNotifications from './components/Notification/PopupNotifications';
import RedirectComponent from './components/Redirect';
import ScrollToTop from './components/RouterScroller';
import Route from './routes/SentryRoute';
import { history, store } from './store';
import theme from './theme';

const App = () => {
  const { ready, i18n } = useTransl('', { useSuspense: false });

  useEffect(() => {
    if (!ready) return;
    hideSplashScreen();
    moment.locale(i18n.language);
    window.i18nLang = i18n.language; // configure date-fns locale
  }, [ready]);

  if (!ready) {
    return null;
  }

  return (
    <Provider store={store}>
      <Router history={history}>
        <ErrorBoundary>
          <ScrollToTop>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <LayoutComponent>
                  <Switch>
                    <Route
                      path="/call-center-dashboard"
                      component={MainCallCenterComponent}
                    />
                    <Route
                      path="/delivery-self-sign-out"
                      component={DeliverySelfSingOutContainer}
                    />
                    <Route path="/redirect" component={RedirectComponent} />
                    <Route path="/" component={MainContainer} />
                  </Switch>
                  <PopupNotifications />
                </LayoutComponent>
                <Grid id="print_area" />
              </ThemeProvider>
            </StyledEngineProvider>
          </ScrollToTop>
        </ErrorBoundary>
      </Router>
    </Provider>
  );
};

export default Sentry.withProfiler(App);
